import ProductSubscriptionDeliveryMessage from './ProductSubscriptionDeliveryMessage'
export default ProductSubscriptionDeliveryMessage
